export enum ROLES_MAP {
  admin = 'ROLE_ADMIN',
  client = 'ROLE_USER',
  ambassador = 'ROLE_AMBASSADOR',
  expert = 'ROLE_EXPERT'
}
